export default "__VITE_ASSET__Bjf9950D__"